<template>
    <div class="asq_se_table">
        <div class="instructions-wrapper">
          <div class="instructions-btn" @click="toggleInstructions()">
            <span class="instru-btn-text">Instructions</span>
            <img src="../../../assets/images/eye-white.svg" class="instru-eye-icon" v-show="!showInstructions"/>
            <img src="../../../assets/images/eye-open-white.svg" class="instru-eye-icon" v-show="showInstructions"/>
          </div>
          <div class="instructions-content" v-show="showInstructions">
            <div class="instru-line">You may use this form to track a child's ASQ:SE screening results over time. Write the date the ASQ:SE was administered at the top of each column.</div>
            <div class="instru-line"><span class="instru-bullet">1.</span>Mark the bubble that corresponds with the ASQ:SE result (refer to the completed ASQ:SE Information Summary). If a score is below the monitoring zone, mark the bubble for “Well Below.” If a score is within the monitoring zone, mark “Monitor.” If a score is above the cutoff, mark “Above.”</div>
            <div class="instru-line"><span class="instru-bullet">2.</span>Indicate the total number of scored items that the caregiver marked as a Concern.</div>
            <div class="instru-line"><span class="instru-bullet">3.</span>Mark “yes” or “No” to indicate whether there were items of Concern in the Overall section and whether there was a parent conference.</div>
            <div class="instru-line"><span class="instru-bullet">4.</span>Record any follow-up action of notes.</div>
            <div class="instru-line"><span class="instru-bullet">5.</span><span style="font-weight: bold;">Optional:</span> Calculate an average item score* by dividing the ASQ:SE total score by the number of answered scored items.</div>
          </div>
        </div>
        <div class="table">
            <div class="column" :style="{maxWidth: '155px'}">
                <div class="row com-pul-title" :style="{borderBottom: 'none', borderRight: 'none'}">
                </div>
                <div class="row date-given">
                </div>
                <div class="row">
                    <div class="row-label"><p>Cut off</p></div>
                    <div class="row-label"><p>Total score</p></div>
                    <div class="row-label"><p>Interpretation</p></div>
                </div>
                <div class="row">
                    <div class="row-label"><p># of scored items with Concern checked</p></div> 
                </div>
                <div class="row">
                  <div class="row-label" ><p>Overall concerns indicated</p></div> 
                </div>
                <div class="row">
                  <div class="row-label"><p>Parent Conference</p></div> 
                </div>
                <div class="row">
                  <div class="row-label"><p>Follow up action/ notes</p></div> 
                </div>
                <div class="row">
                  <div class="row-label"><p>Optional: Avg. item score*</p></div> 
                </div>
            </div>
            <div class="column" v-for="(question, key) in question.question" :key="key">
                <div class="disable-overlay" v-show="columns[question.compulsoryPoint] && columns[question.compulsoryPoint].disable"></div>
                <div class="row com-pul-title" :style="{borderBottom: 'none', borderRight: 'none'}">
                    <p>ASQ:SE</p>
                    <p class="title">{{ question.pointTitle }}</p>
                </div>
                <div class="row date-given">
                  <p class="title-blue date-given-text">Assessed:</p>
                  <!-- <input type="text" value="" placeholder="00/00/00"/> -->
                  <CustomCalenderTypeable :id="question.compulsoryPoint" :defaultDate="updatedAnswer[question.compulsoryPoint] ? updatedAnswer[question.compulsoryPoint].dateGiven : ''" @input="updateDateGiven"></CustomCalenderTypeable>
                </div>
                <div class="row">
                    <div class="cell-text">
                        <p>{{question.cutoff}}</p>
                    </div>
                    <div class="cell-input" :style="{height: '39px'}">
                      <input @input="evt => updateTotalScore(evt, question.compulsoryPoint, question.cutoff, question.belowCutoff)" 
                          :value="updatedAnswer[question.compulsoryPoint] ? updatedAnswer[question.compulsoryPoint].totalScore : ''"
                          class="number-input" type="number" placeholder="#"/>
                    </div>
                    <div class="cell-text">
                        <div v-if="interpretation[question.compulsoryPoint] == ''" class="inter-empty">{{interpretation[question.compulsoryPoint]}}</div>
                        <div v-else-if="interpretation[question.compulsoryPoint] == 'Refer'" class="inter-refer">{{interpretation[question.compulsoryPoint]}}</div>
                        <div v-else-if="interpretation[question.compulsoryPoint] == 'Monitor'" class="inter-monitor">{{interpretation[question.compulsoryPoint]}}</div>
                        <div v-else class="inter-low-risk">{{interpretation[question.compulsoryPoint]}}</div>
                    </div>
                </div>
                <div class="row">
                  <div class="cell-input" :style="{height: '57px'}">
                    <input @input="evt => updateCheckedNumber(evt, question.compulsoryPoint)" 
                        :value="updatedAnswer[question.compulsoryPoint] ? updatedAnswer[question.compulsoryPoint].checkedNumber : ''"
                        class="number-input" type="number" placeholder="#"/>
                  </div>
                </div>
                <div class="row">
                  <div class="cell-input" :style="{height: '57px'}">
                    <YesNoToggleButton :id="question.compulsoryPoint" @input="updateOverallConcern" :defaultValue="updatedAnswer[question.compulsoryPoint] ? updatedAnswer[question.compulsoryPoint].overallConcern : 'No'"/>
                  </div>
                </div>
                <div class="row">
                  <div class="cell-input" :style="{height: '39px'}">
                    <YesNoToggleButton :id="question.compulsoryPoint" @input="updateParentConference" :defaultValue="updatedAnswer[question.compulsoryPoint] ? updatedAnswer[question.compulsoryPoint].parentConference : 'No'"/>
                  </div>
                </div>
                <div class="row">
                  <div class="cell-input" :style="{height: '57px'}">
                    <!-- <img src="../../../assets/images/notes.svg" :style="{width: '22px', cursor: 'pointer'}" @click="showNotesPopup(question.compulsoryPoint)"/> -->
                    <NotesPopup v-if="updatedAnswer[question.compulsoryPoint] && updatedAnswer[question.compulsoryPoint].notes"
                      :id="question.compulsoryPoint" 
                      :title="question.pointTitle"
                      :defaultValue="updatedAnswer[question.compulsoryPoint] ? updatedAnswer[question.compulsoryPoint].notes : ''"

                    ></NotesPopup>
                  </div>
                </div>
                <div class="row">
                  <div class="cell-input" :style="{height: '57px'}">
                    <input @input="evt => updateAvgScore(evt, question.compulsoryPoint)" 
                        :value="updatedAnswer[question.compulsoryPoint] ? updatedAnswer[question.compulsoryPoint].avgScore : ''"
                        class="number-input" type="number" placeholder="#"/>
                    <!-- <input type="text" value="#"/> -->
                  </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import YesNoToggleButton from '@/components/YesNoToggleButton';
import CustomCalenderTypeable from '@/components/CustomCalenderTypeable';
import NotesPopup from '@/components/NotesPopup.vue';

export default {
  name: 'AsqSeTable',
  components: {
    // Dropdown,
    YesNoToggleButton,
    CustomCalenderTypeable,
    NotesPopup
},
  props: {
    question: {
      type: Object,
      required: true,
    },
    answer: {
      type: [Object,String],
      required: false,
    },
  },
  data() {
    return {
      updatedAnswer: {},
      checked: false,
      checkedCompulsoryPoint: false,
      interpretation:{},
      columns: {},
      showInstructions: false
    }
  },
  watch: {
    answer(newAnswer, oldAnswer) {
      if(typeof newAnswer === 'string')
      {
        this.updatedAnswer = JSON.parse(newAnswer);
      }
    }
  },
  methods: {
    updateDateGiven(date, compulsoryPoint) {
      this.toggleColumn(compulsoryPoint);
    //   let dd = String(date.getDate()).padStart(2, '0');
    //   let mm = String(date.getMonth() + 1).padStart(2, '0'); //January is 0!
    //   let yyyy = date.getFullYear();
    //   let newDate = dd + '/' + mm + '/' + yyyy;
    //   console.log(newDate);
     if(!this.updatedAnswer[compulsoryPoint]) {
        this.updatedAnswer[compulsoryPoint] = {};
        this.updatedAnswer[compulsoryPoint].dateGiven = date;
      } else {
        this.updatedAnswer[compulsoryPoint].dateGiven = date;
      }
      this.$emit('input', this.updatedAnswer);
    },
    updateTotalScore(evt, compulsoryPoint, cutoff, belowCutoff) {
      this.toggleColumn(compulsoryPoint);
      let totalScore = evt.target.value;
      if(!this.updatedAnswer[compulsoryPoint]) {
        this.updatedAnswer[compulsoryPoint] = {};
        this.updatedAnswer[compulsoryPoint].totalScore = totalScore;
      } else {
        this.updatedAnswer[compulsoryPoint].totalScore = totalScore;
      }
      this.interpretation[compulsoryPoint] = this.getInterpertation(totalScore, cutoff, belowCutoff);
      this.interpretation = JSON.parse(JSON.stringify(this.interpretation)); // for forcing update dom
      this.$emit('input', this.updatedAnswer);
    },
    updateCheckedNumber(evt, compulsoryPoint) {
      this.toggleColumn(compulsoryPoint);
      let value = evt.target.value;
      if(!this.updatedAnswer[compulsoryPoint]) {
        this.updatedAnswer[compulsoryPoint] = {};
        this.updatedAnswer[compulsoryPoint].checkedNumber = value;
      } else {
        this.updatedAnswer[compulsoryPoint].checkedNumber = value;
      }
      this.$emit('input', this.updatedAnswer);
    },
    updateOverallConcern(value, compulsoryPoint) {
      this.toggleColumn(compulsoryPoint);
      //this.checked = !this.checked;
      if(!this.updatedAnswer[compulsoryPoint]) {
        this.updatedAnswer[compulsoryPoint] = {};
        this.updatedAnswer[compulsoryPoint].overallConcern = value;
      } else {
        this.updatedAnswer[compulsoryPoint].overallConcern = value;
      }
      this.$emit('input', this.updatedAnswer);
    },
    updateParentConference(value, compulsoryPoint) {
      this.toggleColumn(compulsoryPoint);
        //this.checkedParentConference = !this.checkedParentConference;
      if(!this.updatedAnswer[compulsoryPoint]) {
        this.updatedAnswer[compulsoryPoint] = {};
        this.updatedAnswer[compulsoryPoint].parentConference = value;
      } else {
        this.updatedAnswer[compulsoryPoint].parentConference = value;
      }
      this.$emit('input', this.updatedAnswer);
    },
    updateNotes(value, compulsoryPoint) {
      if(!this.updatedAnswer[compulsoryPoint]) {
        this.updatedAnswer[compulsoryPoint] = {};
        this.updatedAnswer[compulsoryPoint].notes = value;
      } else {
        this.updatedAnswer[compulsoryPoint].notes = value;
      }
      this.$emit('input', this.updatedAnswer);
    },
    updateAvgScore(evt, compulsoryPoint) {
      this.toggleColumn(compulsoryPoint);
      let value = evt.target.value;
      if(!this.updatedAnswer[compulsoryPoint]) {
        this.updatedAnswer[compulsoryPoint] = {};
        this.updatedAnswer[compulsoryPoint].avgScore = value;
      } else {
        this.updatedAnswer[compulsoryPoint].avgScore = value;
      }
      this.$emit('input', this.updatedAnswer);
    },
    getInterpertation(score, cutoff, belowCutoff) {
      if(!score) {return '';}
      if(score > cutoff) {
        return 'Refer';
      } else {
        return 'No/Low risk';
      }
      // else if (score < belowCutoff) {
      //   return 'No/Low risk';
      // } 
      // else {
      //   return 'Monitor';
      // }
    },
    showNotesPopup(compulsoryPoint) {
      console.log(compulsoryPoint);
    },
    toggleColumn(compulsoryPoint) {
      for (let cPoint in this.columns) {
        if (this.columns[cPoint]) {
          this.columns[cPoint].disable = true;
        }
      }
      this.columns[compulsoryPoint].disable = false;
      localStorage.setItem('compulsoryPoint', compulsoryPoint);
      this.columns = JSON.parse(JSON.stringify(this.columns));
    },
    toggleInstructions() {
      this.showInstructions = !this.showInstructions;
    }
  },
  mounted() {
    if(typeof this.answer === 'string') {
      this.updatedAnswer = JSON.parse(this.answer);
    }
    this.question.question.forEach(q => {
      if(!this.columns[q.compulsoryPoint]) {
        this.columns[q.compulsoryPoint] = {};
        this.columns[q.compulsoryPoint].disable = false;
      } else {
        this.columns[q.compulsoryPoint].disable = false;
      }
      
      if(this.updatedAnswer[q.compulsoryPoint]) {
        this.interpretation[q.compulsoryPoint] = this.getInterpertation(this.updatedAnswer[q.compulsoryPoint].totalScore, q.cutoff, q.belowCutoff);
      } else {
        this.interpretation[q.compulsoryPoint] = ''
      }
    })
  }
};
</script>
<style lang="scss" scoped>
.asq_se_table{
  margin-top: -105px;
  margin-bottom: 10px;
}
.asq_se_table{
    .table{
        .vdp-datepicker {
            width: 75%;
        }
        input{
            border: none!important;
            height: 30px;
            border-radius: 12px 12px 12px 0px;
            text-align: center;
            width: 75%;
            background: #e4f4f9;
            outline: none;
            display: block;
            margin: 0 auto;
            font-size: 13px;
        }
        p{
            margin: 0;
            &.title-blue{
                color: #1381A2;
                font-size: 13px;
            }
            &.bold{
                font-weight: 600;
                min-height: 40px;
            }
        }
        display: flex;
        flex-direction: row;
        color: #414142;
        .column{
            position: relative;
            &.head{
                max-width: 110px;
            }
            &.data{
                max-width: 100px;
            }
            
            display: flex;
            flex-direction: column;
            // border-right: 1px solid #1381A2;
            .row{
                border-bottom: 1px solid #5ABBD8;
                border-right: 1px solid #5ABBD8;
            }
        }
    }

    .com-pul-title {
      height: 42px;
      padding-bottom: 9px;
      padding-left: 12px;
      font-size: 14px;
      .title {
        font-weight: bold;
      }
    }

    .date-given {
      height: 68px;
      padding-bottom: 10px;
      padding-left: 12px;
      .date-given-text {
        margin-bottom: 3px;
      }
    }

    .row-label {
      font-size: 15px;
      padding-top: 13px;
      padding-bottom: 8px;
      padding-right: 15px;
      text-align: right;
      width: 155px;
    }

    .cell-text {
      font-size: 15px;
      display: flex;
      align-items: center;
      justify-content: center;
      padding-top: 13px;
      padding-bottom: 8px;
    }

    .cell-input {
      display: flex;
      align-items: center;
      justify-content: center;
    }

    .number-input::-webkit-outer-spin-button,
    .number-input::-webkit-inner-spin-button {
      -webkit-appearance: none;
      margin: 0;
    }

    .inter-empty {
      height: 18px;
    }

    .inter-refer {
      background: #D4494E;
      width: 86px;
      display: flex;
      align-items: center;
      justify-content: center;
      color: white;
      border-radius: 20px;
      height: 18px;
      font-size: 13px;
    }

    .inter-monitor {
      background: #FFC93E;
      width: 86px;
      display: flex;
      align-items: center;
      justify-content: center;
      border-radius: 20px;
      height: 18px;
      font-size: 13px;
    }

    .inter-low-risk {
      background: #7ABE7B;
      width: 86px;
      display: flex;
      align-items: center;
      justify-content: center;
      color: white;
      border-radius: 20px;
      height: 18px;
      font-size: 13px;
    }
}

.disable-overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: calc(100% + 1px);;
  height: 100%;
  background-color: rgba(255, 255, 255, 0.8);
  z-index: 1;
  margin-left: -1px;
  // backdrop-filter: blur(8px);
}

.instructions-wrapper {
  position: relative;
  margin-bottom: 20px;
}

.instructions-btn {
  display: flex;
  align-items: center;
  width: 200px;
  height: 36px;
  border-radius: 20px;
  border-bottom-left-radius: 0px;
  background-color: #1381A2;
  cursor: pointer;
}

.instru-btn-text {
  color: white;
  margin-left: 25px;
}

.instru-eye-icon {
  width: 22px; 
  margin-left: auto; 
  margin-right: 15px;
}

.instructions-content {
  position: absolute;
  top: 40px;
  left: 0px;
  background-color: white;
  padding: 25px;
  border-radius: 25px;
  border-top-left-radius: 0px;
  box-shadow: 2px 4px 6px 6px #00000029;
  z-index: 9;
  color: #239bbe;
  font-size: 15px;
}

.instru-bullet {
  margin-right: 7px;
  font-weight: bold;
}

.instru-line {
  margin-bottom: 10px;
}
</style>